import styled, { css } from 'styled-components';

import { rgba } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $CountrySelector = styled.div`
  position: relative;
`;

export const $ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const $FlagWrapper = styled.span<{ $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 ${spacing('xs')};
  ${({ $disabled }) => ($disabled ? 'opacity: 0.75;' : '')}
`;

export const $DropdownArrow = styled.div<{
  $active?: boolean;
  $disabled?: boolean;
}>`
  border-top: 4px solid
    ${({ $disabled, theme }) =>
      $disabled ? theme.colors.disabled : theme.colors.mainTextColor};
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-right: ${spacing('xs')};
  transition: all 100ms ease-out;
  ${({ $active }) => ($active ? 'transform: rotate(-180deg);' : '')}
`;

export const $CountrySelectorButton = styled.button<{
  $disabled?: boolean;
  $hideDropdown?: boolean;
}>`
  display: flex;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0 ${spacing('md')};
  border: none;
  border-right: 1px solid ${({ theme }) => theme.colors.default};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin: 0;
  appearance: button;
  -webkit-appearance: button;
  background-color: white;
  cursor: pointer;
  text-transform: none;
  user-select: none;

  &:hover {
    background-color: ${({ theme }) => rgba(theme.colors.primary, 0.05)};
  }

  outline: none;

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.primary};
  }

  ${({ $hideDropdown }) =>
    $hideDropdown
      ? css`
          cursor: auto;
          &:hover {
            background-color: transparent;
          }
        `
      : css``}

  ${({ $disabled }) =>
    $disabled
      ? css`
          background-color: whitesmoke;
          cursor: auto;
          &:hover {
            background-color: whitesmoke;
          }
        `
      : css``}
`;
